import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { LoaderService } from '@core/services/loader.service';
import { LoaderState } from '@shared/models/loader';


@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {

  show = false;
  private subscription: Subscription;

  constructor(
    private loaderService: LoaderService
  ) { }

  ngOnInit() {
    this.subscription = this.loaderService.currentValue
            .subscribe((state: boolean) => {
                this.show = state;
            });
  }

  OnDestroy() {
    this.subscription.unsubscribe();
  }

}
